import { useQuery } from "react-query";
import { getCarriersCount } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetCarriersCount = () => {
  return useQuery("GetCarriersCount", getCarriersCount, {
    refetchOnWindowFocus: false,
  });
};
